import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AdminNavBar from "../../NavBar/AdminNavBar";
import style from "./UpdateProject.module.css";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function UpdateProject() {
    const { projectId, employeeId } = useParams();
    const [loadingUsers, setLoadingUsers] = useState(false);
    const apiurl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    const navigate = useNavigate();
    const selectRef = useRef(null);

    const [project, setProject] = useState({
        title: "",
        client: "",
        clientEmail: "",
        description: "",
        platform: "",
        team: "",
        type: "",
        status: "",
        priority: "",
        progress: "",
        employeeId: [],
        manager: "",
        createdBy: "",
        startDate: "",
        endDate: "",
        deadLine: "",
        budget: "",
        spent: "",
        pending: "",
    });

    const [users, setUsers] = useState([]);
    const [error, setError] = useState("");

    // Fetch project details
    useEffect(() => {
        const fetchProject = async () => {
            try {
                const res = await fetch(`${apiurl}/projects/${projectId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });

                const data = await res.json();
                if (res.ok) {
                    setProject(data.projects);
                } else {
                    setError(data.message || "Failed to fetch project");
                }
            } catch (err) {
                setError(err.message);
            }
        };

        fetchProject();
    }, [apiurl, projectId, token]);

    // Fetch all users (for manager & employees)
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await fetch(`${apiurl}/users`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                const data = await res.json();
                if (res.ok) {
                    setUsers(data.users || []);
                } else {
                    setError(data.message || "Failed to fetch users");
                }
            } catch (err) {
                setError(err.message);
            }
        };

        fetchUsers();
    }, [apiurl, token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProject((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Exclude title from update (backend restriction)
            const { title, ...updates } = project;

            const res = await fetch(`${apiurl}/projects/${projectId}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(updates),
            });

            const data = await res.json();

            if (res.ok) {
                alert("✅ Project updated successfully!");
                navigate(`/admin-dashboard/${employeeId}/all-projects`);
            } else {
                alert(`❌ ${data.message || "Failed to update project"}`);
            }
        } catch (err) {
            alert(err.message);
        }
    };


    // Add employee to project
    const handleSelectEmployees = (e) => {
        const selectedId = e.target.value;
        if (selectedId && !project.employeeId.includes(selectedId)) {
            setProject((prev) => ({
                ...prev,
                employeeId: [...prev.employeeId, selectedId],
            }));
        }
        e.target.value = "";
    };

    // Remove last employee
    const handleRemoveLast = () => {
        setProject((prev) => ({
            ...prev,
            employeeId: prev.employeeId.slice(0, -1),
        }));
    };
    // Filter employees for dropdown
    const availableUsers = users.filter(
        (u) => u.role === "Employee" && !project.employeeId.includes(u.employeeId)
    );

    const managerUsers = users.filter((u) => u.role === "Manager");

    if (error) return <p className="text-danger text-center">{error}</p>;
    if (!project) return <p className="text-center mt-4">Loading...</p>;

    return (
        <div className="container pt-lg-4">
            <AdminNavBar />

            <div style={{ display: 'none' }}>
                {setLoadingUsers ? <p>yes</p> : <p>no</p>}
            </div>
            <div className="col-8 col-lg-8 pb-4 ">
                <BreadCrumb
                    link={`/admin-dashboard/${employeeId}`}
                    name="Dashboard"
                    icon={true}
                />
                <BreadCrumb
                    link={`/admin-dashboard/${employeeId}/all-projects`}
                    name="All Projects"
                    icon={true}
                />
                <BreadCrumb
                    link={`/admin-dashboard/${employeeId}/projects/${projectId}`}
                    name={` Update Project on ${project.title}`}
                />
            </div>


            <div className="card p-4 shadow mb-5">

                <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">Title</label>
                            <input
                                type="text"
                                name="title"
                                value={project.title}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* client */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">client</label>
                            <input
                                type="text"
                                name="client"
                                value={project.client}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* description */}
                        <div className="col-md-12">
                            <label className="form-label fw-semibold">Description</label>
                            <textarea
                                type="text"
                                name="description"
                                value={project.description}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* platform */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Platform</label>

                            <select
                                name="platform"
                                className={`form-select ${style.formSelect}`}
                                value={project.platform}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Platform</option>
                                <option value="MERN">MERN</option>
                                <option value="MEAN">MEAN</option>
                                <option value="Java">Java</option>
                                <option value="React">React</option>
                                <option value="Python">Python</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>

                        {/* team */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Team</label>
                            <select
                                name="team"
                                className={`form-select ${style.formSelect}`}
                                value={project.team}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Team</option>
                                <option value="MERN Development">MERN Development</option>
                                <option value="Backend Development">Backend Development</option>
                                <option value="FrontEnd Development">FrontEnd Development</option>
                                <option value="UI Development">UI Development</option>
                                <option value="UI Designing">UI Designing</option>
                                <option value="UI/UX Design">UI/UX Design</option>
                                <option value="QA Testing">QA Testing</option>
                                <option value="DevOps">DevOps</option>
                                <option value="React">React</option>
                            </select>
                        </div>

                        {/* type */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Type</label>
                            <select
                                name="type"
                                className={`form-select ${style.formSelect}`}
                                value={project.type}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select Type</option>
                                <option value="Planning">Planning</option>
                                <option value="Development">Development</option>
                                <option value="Designing">Designing</option>
                                <option value="Testing">Testing</option>
                                <option value="Deployment">Deployment</option>
                                <option value="Maintenance">Maintenance</option>
                            </select>
                        </div>

                        {/* status */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Status</label>
                            <select
                                name="status"
                                value={project.status}
                                onChange={handleChange}
                                className="form-select"
                            >
                                <option value="">Select Status</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Completed">Completed</option>
                                <option value="Pending">Pending</option>
                            </select>
                        </div>

                        {/* priority */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Priority</label>
                            <select
                                name="priority"
                                value={project.priority}
                                onChange={handleChange}
                                className="form-select"
                            >
                                <option value="">Select Priority</option>
                                <option value="High">High</option>
                                <option value="Medium">Medium</option>
                                <option value="Low">Low</option>
                            </select>
                        </div>

                        {/* project Completion */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Project Level (%)</label>
                            <input
                                type="number"
                                name="progress"
                                value={project.progress}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* Employee selection */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Add Employee</label>
                            <select
                                ref={selectRef}
                                className="form-select"
                                onChange={handleSelectEmployees}
                                value={project.employeeId}
                            >
                                <option value="">Select Employee</option>
                                {loadingUsers ? (
                                    <option disabled>Loading...</option>
                                ) : (
                                    availableUsers.map((u) => (
                                        <option key={u.employeeId} value={u.employeeId}>
                                            {u.employeeId} - {u.firstName}  {u.lastName}
                                        </option>
                                    ))
                                )}
                            </select>
                        </div>

                        {/* manager */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Manager</label>
                            <select
                                name="manager"
                                value={project.manager}
                                onChange={handleChange}
                                className="form-select"
                            >
                                <option value="">Select Manager</option>
                                {managerUsers.map((user) => (
                                    <option key={user.employeeId} value={user.name}>
                                        {user.employeeId} - {user.firstName}                                     </option>
                                ))}
                            </select>
                        </div>

                        {/* created By */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Created By</label>
                            <input
                                type="text"
                                name="createdBy"
                                value={project.createdBy}
                                onChange={handleChange}
                                className="form-control"
                                disabled
                            />
                        </div>

                        {/* Assigned Employees display */}
                        <div className="col-md-8  ">
                            <label htmlFor="employeeId" className="fw-bold">
                                Assigned Employees
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    id="employeeId"
                                    name="employeeId"
                                    className="form-control"
                                    value={project.employeeId?.join(", ") || ""}
                                    onChange={(e) =>
                                        setProject({
                                            ...project,
                                            employeeId: e.target.value
                                                .split(",")
                                                .map((id) => id.trim())
                                                .filter(Boolean),
                                        })
                                    }
                                    placeholder="Enter employee IDs separated by commas"
                                />
                                <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={handleRemoveLast}
                                    disabled={project.employeeId.length === 0}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>

                        {/* client email */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Client Email</label>
                            <input
                                type="text"
                                name="clientEmail"
                                value={project.clientEmail}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* start date */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Start Date</label>
                            <input
                                type="date"
                                name="startDate"
                                value={project.startDate ? project.startDate.substring(0, 10) : ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* end date */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">End Date</label>
                            <input
                                type="date"
                                name="endDate"
                                value={project.endDate ? project.endDate.substring(0, 10) : ""}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* deadline */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Deadline </label>
                            <input
                                type="date"
                                name="deadLine"
                                value={project.deadLine ? project.deadLine.split('T')[0] : ''}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* budget */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Budget</label>
                            <input
                                type="text"
                                name="budget"
                                value={project.budget}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* spent */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Spent</label>
                            <input
                                type="text"
                                name="spent"
                                value={project.spent}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        {/* pending */}
                        <div className="col-md-4">
                            <label className="form-label fw-semibold">Pending</label>
                            <input
                                type="text"
                                name="pending"
                                value={project.pending}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>

                        <div className="text-center mt-4">
                            <button type="submit" className="btn btn-primary px-4">
                                Update Project
                            </button>
                        </div>
                    </div>
                </form>
            </div >
        </div >
    );
}
